/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchCmsDrugCriteriaList = (data) => ({
  type: actionTypes.GET_CMS_DRUG_BY_CRITERIA,
  searchDrugByCriteriaList: data,
});

export const dispatchManufacturerData = (data) => ({
  type: actionTypes.GET_MANUFACTURER_DATA_DFD,
  manufacturerList: data,
});

export const dispatchSuccessPayload = (data) => ({
  type: actionTypes.SUCCESSFUL_DATA_PAYLOAD,
  sucessPayload: data,
});

export const dispatchCmsDrugCriteria = (data) => ({
  type: actionTypes.GET_SEARCH_CMS_DRUG_BY_CRITERIA_LIST,
  searchCmsDrugByCriteriaList: data,
});

export const getCmsDrugByCriteria = (value) => (dispatch) => {
  dispatch(dispatchSuccessPayload(value));
  return axios
    .post(serviceEndPoint.GET_DRUG_DETAILS_CMS_DISCREPANCIES, value)
    .then((response) => {
      return handleExistingCommentList(
        response.data && response.data.cmsDrugResponse,
        dispatch
      );
    })
    .catch(() => {
      dispatch(dispatchCmsDrugCriteriaList([]));
    });
};

export const handleExistingCommentList = async (detailspagetable, dispatch) => {

  if (detailspagetable && detailspagetable.length > 0) {
   
    const result = await getExistingCorrLinkIds({
      corrLinkId: detailspagetable.map((item) => {
        return item.corrLinkId;
      }),
    });
    const tempObj =
      detailspagetable &&
      detailspagetable.map((item) => {
        if (
          result &&
          result.data?.length > 0 &&
          result.data?.filter((x) => {
            return x === item.corrLinkId;
          }).length > 0
        ) {
          item.ccCommentsExist = 1;
        } else {
          item.ccCommentsExist = 0;
        }
        return item;
      });

    return dispatch(dispatchCmsDrugCriteriaList(tempObj));

  }
  else{
    return dispatch(dispatchCmsDrugCriteriaList([]));
  }
};

export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURER_DETAILS, value)
    .then((response) => {
      return dispatch(
        dispatchManufacturerData(response.data && response.data.data)
      );
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};

export const setSearchCmsDrugTab = (data) => {
  return {
    type: actionTypes.SEARCH_CMS_DRUG_TAB_DATA,
    searchCmsDrugObj: data,
  };
};
export const setCmsDrugDetailTab = (data) => {
  return {
    type: actionTypes.CMS_DRUG_DETAIL_TAB_DATA,
    cmsDrugDetailObj: data,
  };
};

export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_DFD,
  errorMessagesInRedux: data,
});
export const dispatchAuditTypeDropDownList = (data) => ({
  type: actionTypes.GET_AUDIT_TYPE_DFD,
  auditTypeList: data,
});

export const getAuditTypeDropDownList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_AUDIT_TYPE_LIST, value)
    .then((response) => {
      return dispatch(
        dispatchAuditTypeDropDownList(
          response.data && response.data.invoiceAuditResponse
        )
      );
    })
    .catch(() => {
      dispatch(dispatchAuditTypeDropDownList([]));
    });
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const dispatchUpdateAuditClearedIndex = (data) => ({
  type: actionTypes.UPDATE_AUDIT_CLEARED_INDEX_DATA_DFD,
  auditClearedIndexData: data,
});

export const updateAuditClearedIndex = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_ROSI_AUDIT_CLEARED_INDEX, value)
    .then((response) => {
      return dispatch(dispatchUpdateAuditClearedIndex(response.data));
    })
    .catch(() => {
      dispatch(dispatchUpdateAuditClearedIndex([]));
    });
};

export const setPreviousDrugData = (data) => {
  return {
    type: actionTypes.PREVIOUS_DRUG_DATA_DFD,
    previousData: data,
  };
};

export const setDetailScreenObj = (data) => {
  return {
    type: actionTypes.DETAIL_SCREEN_OBJ_DFD,
    detailScreenObj: data,
  };
};

export const setMfgSelected = (data) => {
  return {
    type: actionTypes.MFG_SELECTED,
    mfgSelected: data,
  };
};

export const resetRedux = (payload) => {
  return {
    type: actionTypes.RESET_REDUX_DFD,
  };
};

// clear redux
export const clearCmsDrugFileDiscrepancies = () => (dispatch) => {
  dispatch(setSearchCmsDrugTab({}));
  dispatch(setCmsDrugDetailTab({}));
  dispatch(dispatchManufacturerData([]));
  dispatch(dispatchAuditTypeDropDownList([]));
  dispatch(handleErrorMessages({}));
  dispatch(dispatchCmsDrugCriteria({}));
  dispatch(setPreviousDrugData([]));
  dispatch(setDetailScreenObj({}));
  dispatch(dispatchSuccessPayload({}));
  dispatch(setMfgSelected({}));
}
